import React, { useState, useEffect } from 'react'
import api from '../../../../Services/api';
import axios from 'axios';
import { Bar } from 'react-chartjs-2';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import LcrReport from './lcrReport';
import ChartDataLabels from 'chartjs-plugin-datalabels';  
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import MonthlyComplianceReport from './MonthlyComplianceReport';



const months = [
    { name: "JANUARY", value: "01" },
    { name: "FEBRUARY", value: "02" },
    { name: "MARCH", value: "03" },
    { name: "APRIL", value: "04" },
    { name: "MAY", value: "05" },
    { name: "JUNE", value: "06" },
    { name: "JULY", value: "07" },
    { name: "AUGUST", value: "08" },
    { name: "SEPTEMBER", value: "09" },
    { name: "OCTOBER", value: "10" },
    { name: "NOVEMBER", value: "11" },
    { name: "DECEMBER", value: "12" }
];

const ReportSection = () => {
     const [openDialog, setOpenDialog] = useState(false);
              const [openDialogComplianceReport, setOpenDialogComplianceReport] = useState(false);
        const currentYear = new Date().getFullYear();
        const years = Array.from({ length: currentYear - 2020 + 1 }, (x, i) => 2020 + i);
       
        const[selectedMonth,setSelectedMonth] = useState('');
        const [selectedYearForReport, setSelectedYearForReport] = useState('');
              const handleMonthChange = (event) => {
                setSelectedMonth(event.target.value);
            };
            const handleYearChanges = (event) => {
                setSelectedYearForReport(event.target.value);
            };
    
              const handleOpenDialog = () => {
                setOpenDialog(true);
              };
            
              const handleCloseDialog = () => {
                setOpenDialog(false);
              };
              const handleOpenDialogComplianceReport = () => {
                setOpenDialogComplianceReport(true);
              };
            
              const handleCloseDialogComplianceReport = () => {
                setOpenDialogComplianceReport(false);
              };
  return (
    <div>
                         <h6 className="bg-dark text-center text-light p-3">Report</h6>
                 <section className="d-grid" style={{border:'1px solid lightgray'}}>

  <div className="justify-content-center align-items-center text-center">
    <h6 className="p-2 bg-light text-dark" style={{borderBottom:'1px solid lightgray'}}>Vendor Details</h6>
    <button className="m-3 btn btn-danger btn-sm" onClick={handleOpenDialog}>
      View Report
    </button>
  </div>


  <div className="text-center">
    <h6 className="p-2 bg-light text-dark" style={{borderBottom:'1px solid lightgray',borderTop:'1px solid lightgray'}}>Vendor Monthly Compliance Report</h6>

    <div className="d-flex justify-content-center p-3">
      <select
        className="p-1 text-dark"
        value={selectedMonth || ''}
        onChange={handleMonthChange}
        style={{ border: '1px solid lightgray', borderRadius: '4px', cursor: 'pointer' }}
      >
        <option value="" disabled>
          Select Month
        </option>
        {months.map((month) => (
          <option key={month.value} value={month.value}>
            {month.name}
          </option>
        ))}
      </select>

      <select
        className="p-1 mx-2 text-dark"
        value={selectedYearForReport || ''}
        onChange={handleYearChanges}
        style={{ border: '1px solid lightgray', borderRadius: '4px', cursor: 'pointer' }}
      >
        <option value="" disabled>
          Select Year
        </option>
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </div>

    <button className="btn btn-danger btn-sm mb-3" onClick={handleOpenDialogComplianceReport}>
      View Report
    </button>
  </div>
</section>

                                
         
                                  <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
              <DialogTitle>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span>Export Contractor Data to Excel</span>
                  <Button onClick={handleCloseDialog} color="error">
                    Close
                  </Button>
                </div>
              </DialogTitle>
              
              <DialogContent>
                <LcrReport />
              </DialogContent>
            </Dialog>
      
      
            
            <Dialog open={openDialogComplianceReport} onClose={handleCloseDialogComplianceReport} maxWidth="md" fullWidth>
              <DialogTitle>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span>Export Contractor Data to Excel</span>
                  <Button onClick={handleCloseDialogComplianceReport} color="error">
                    Close
                  </Button>
                </div>
              </DialogTitle>
              
              <DialogContent>
                  {selectedMonth && selectedYearForReport ? (
              <MonthlyComplianceReport month={selectedMonth} year={selectedYearForReport}/>
                  ) : (
                      <div style={{ color: 'red', textAlign: 'center' }}>
                      <p>Please select both a month and a year to view the report.</p>
                    </div>
                  )}
              </DialogContent>
            </Dialog>
    </div>
  )
}

export default ReportSection
